<ng-container *ngFor="let item of navigation">
  <ng-container *ngIf="item.children && item.children.length">
    <medis-nav-vertical-group
      *ngIf="item.type === 'group'"
      [item]="item"
    ></medis-nav-vertical-group>
    <medis-nav-vertical-item *ngIf="item.type === 'item'" [item]="item"></medis-nav-vertical-item>
  </ng-container>
</ng-container>
